<div class="ion-header ion-hide-lg-up sb">
  <header-main></header-main>
  <div class="ion-fab">
    <div class="ion-fab-button close button-tertiary button-round">
      <a href="javascript:void(0)" (click)="goBack()">
        <img class="ion-icon" src="assets/icons/close.svg">
      </a>
    </div>
  </div>
</div>

<main class="ion-content details-wrapper" fullscreen>
  <header class="ion-hide-lg-up ion-padding-top s">
    <div class="container">
      <h1>
        <img class="ion-icon" src="{{article.thumbnail}}"/>
        {{article.title}}
      </h1>
    </div>
  </header>
  <header class="ion-hide-lg-down s">
    <header-desktop></header-desktop>
    <div class="container">
      <h1>
        <img class="ion-icon" src="{{article.thumbnail}}"/>
        {{article.title}}
      </h1>
    </div>
  </header>

  <div class="container-fluid">
    <div class="ion-row">
      <div class="ion-col" size="12" size-md="10" size-lg="8" size-xl="6" offset-md="1" offset-lg="2" offset-xl="3">
        <div class="details-content">
          <div *ngIf="article.content" class="description" [innerHTML]="article.content"></div>
        </div>
      </div>
    </div>
  </div>

  <footer class="ion-hide-lg-down">
    <footer-desktop></footer-desktop>
  </footer>
</main>

<footer class="ion-hide-lg-up">
  <footer-main></footer-main>
</footer>
